import { render, staticRenderFns } from "./SolutionsList.vue?vue&type=template&id=46f272c2&scoped=true"
import script from "./SolutionsList.vue?vue&type=script&lang=js"
export * from "./SolutionsList.vue?vue&type=script&lang=js"
import style0 from "./SolutionsList.vue?vue&type=style&index=0&id=46f272c2&prod&lang=scss&scoped=true"
import style1 from "./SolutionsList.vue?vue&type=style&index=1&id=46f272c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f272c2",
  null
  
)

export default component.exports